import { FC } from "react";

interface UserIconSVGProps {
    className?: string;
}

const UserIconSVG: FC<UserIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M24.0003 26.666C24.0003 24.5443 23.1575 22.5095 21.6572 21.0092C20.1569 19.5089 18.1221 18.666 16.0003 18.666M16.0003 18.666C13.8786 18.666 11.8438 19.5089 10.3435 21.0092C8.84318 22.5095 8.00033 24.5443 8.00033 26.666M16.0003 18.666C18.9458 18.666 21.3337 16.2782 21.3337 13.3327C21.3337 10.3872 18.9458 7.99935 16.0003 7.99935C13.0548 7.99935 10.667 10.3872 10.667 13.3327C10.667 16.2782 13.0548 18.666 16.0003 18.666ZM29.3337 15.9993C29.3337 23.3631 23.3641 29.3327 16.0003 29.3327C8.63653 29.3327 2.66699 23.3631 2.66699 15.9993C2.66699 8.63555 8.63653 2.66602 16.0003 2.66602C23.3641 2.66602 29.3337 8.63555 29.3337 15.9993Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default UserIconSVG;
